<template>
   <section class="wallet-wrapper">
      <div class="container">
         <div class="wallet-sec wallet-head">
            <div class="wallet-icon">
               <img src="@/assets/images/wallet-icon.svg" alt="wallet-icon" loading="lazy" />
            </div>
            <div class="wallet-con">
               <p>Your Total Balance</p>
               <p class="para-three">{{ this.$auth.user?.balance }}</p>
            </div>
         </div>
         <div class="cmn-walletbtn wallet-btn">
            <ul>
               <li>
                  <router-link :to="{name: 'WalletDeposit'}" class="cmn-btnwd thm-but">Wallet deposit</router-link>
               </li>
               <li>
                  <router-link :to="{name: 'WalletWithdraw'}" class="cmn-btnwd thm-but">Wallet Withdraw</router-link>
               </li>
            </ul>
         </div>
      </div>
   </section>

   <section class="wallet-list-wrapper">
      <div class="container">
         <div class="wallet-list-sec wallet_page_wrapper">
            <div class="row g-2">
               <div class="col-12">
                  <router-link :to="{ name: 'WalletHistory'}">
                     <div class="wallet-list-con">
                        <div class="wallet-left-history">
                           <div class="wallet-list-icon">
                              <img src="@/assets/images/wallet-history.svg" alt="wallet-icon" title="wallet-icon" />
                           </div>
                           <div class="thm-heading">
                              <p class="para-three">Wallet history</p>
                           </div>
                        </div>
                        <div class="arrow-right"><img src="@/assets/images/arrow-right-icon.svg" alt="arrow-right" title="View wallet history"></div>
                     </div>
                  </router-link>
               </div>
            </div>
         </div>
      </div>
   </section>
</template>

<script>
export default {
    name: 'Wallet',
    data(){
        return{
        }
    }
}
</script>
<style scoped>
.wallet-head .wallet-con .para-three {
	color: #45fd3c !important;
}
</style>